import React, { use, useContext, useEffect, useRef, useState } from 'react';
import { data, Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import './Invitationhome.css';
import CustomizationModal from './CustomizationModal';
import SuccessModal from './SuccessModal';
import Rectangle from "../../assets/invitations/type-box-1.png"
import boxSize2 from '../../assets/invitations/type-box-2.png'
import boxSize3 from "../../assets/invitations/type-box-3.png"
import sweet1Img from "../../assets/invitations/sweet-1.jpg"
import sweet2Img from "../../assets/invitations/sweet-2.jpg"
import sweet3Img from "../../assets/invitations/sweet-3.jpg"
import sweet4Img from "../../assets/invitations/sweet-4.jpg"
import leftArrow from "../../assets/invitations/arrow-left.png"
import section2 from "../../assets/invitations/section-type-2.png"
import section4 from "../../assets/invitations/section-4.png"
import section3 from "../../assets/invitations/box-3.jpg"
import OneImg from "../../assets/invitations/one.jpg"
import section1One from '../../assets/invitations/section-3-one.jpg';
import section3two from "../../assets/invitations/section-3-two.jpg"
import section3three from "../../assets/invitations/section-3-three.jpg"
import specialBox1 from "../../assets/invitations/special-1.jpg"
import specialBox2 from "../../assets/invitations/special-2.jpg"
import specialBox3 from "../../assets/invitations/special-3.jpg"
import specialBox4 from "../../assets/invitations/special-4.jpg"
import specialBox5 from "../../assets/invitations/special-5.jpg"
import selectSweet from "../../assets/invitations/select-sweet.jpg"
import { AuthContext } from '../context';
import rightArrow from "../../assets/invitations/right-icon.png"
import { useDispatch, useSelector } from 'react-redux';
import { chnageWeight } from '../redux/weightSlice';
import backArrow from "../../assets/sweet/left_arrow.png"
import axios from 'axios';
import { toast } from 'react-toastify';


const sectionBox4 = [
  { name: 'section_box4', id: 1, sectionImg: sweet1Img, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'section_box4', id: 2, sectionImg: sweet2Img, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'section_box4', id: 3, sectionImg: sweet3Img, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'section_box4', id: 4, sectionImg: sweet4Img, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
]

const normalBox = [
  { name: "normal_box", id: 1, sectionImg: OneImg, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
]

const sectionBox3 = [
  { name: 'section_box3', id: 1, sectionImg: section1One, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'section_box3', id: 2, sectionImg: section3two, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'section_box3', id: 3, sectionImg: section3three, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
]

const specialBox = [
  { name: 'special_box', id: 1, sectionImg: specialBox1, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'special_box', id: 2, sectionImg: specialBox2, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'special_box', id: 3, sectionImg: specialBox3, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'special_box', id: 4, sectionImg: specialBox4, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
  { name: 'special_box', id: 4, sectionImg: specialBox5, arrow: leftArrow, sweetImg: selectSweet, price: 120, url: '/sweets' },
]

const boxType = [
  { id: 1, number: 1, boxName: 'Normal Box', boxImg: Rectangle, boxDesc: 'Lorem Ipsum is simply dummy terxt for the printing' },
  { id: 2, number: 2, boxName: '4 Section in box', boxImg: section2, boxDesc: 'this is the dummy content and the' },
  { id: 3, number: 3, boxName: '3 Section in box', boxImg: section3, boxDesc: 'Lorem Ipsum is simply dummy' },
  { id: 4, number: 4, boxName: 'Special box', boxImg: section4, boxDesc: 'Lorem Ipsum is simply' },
]

export const Invitationhome = () => {
  const hasFetchedRef = useRef(false);
  const token = localStorage.getItem("token")
  const userId = localStorage.getItem("_id")
  const { _id, url } = useParams()
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(AuthContext);
  const setAmounts = context?.setAmounts;
  const setInvitationsweet = context.setSelectSweet;
  const setTotalAmountInv = context?.setTotalAmountInv
  const amounts = context?.amounts;
  const boxName = context?.boxName;
  const setBoxName = context?.setBoxName;
  const setPaymentHistory = context?.setPaymentHistory;
  const paymentHistory = context?.paymentHistory;
  const [price, serPrice] = useState()
  const [invitationId, setinvitationId] = useState()
  const [invitation, setInvitation] = useState({})
  const getSweet = location?.state;
  const [selectedSweet, setSelectedSweet] = useState(getSweet)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [id, setId] = useState(1)
  const [total, setTotal] = useState(0)
  const [error, setError] = useState([])
  const [lastURL, setLastURL] = useState(localStorage.getItem('lastURL'));
  const [currentUrl, setCurrentUrl] = useState(localStorage.getItem('currentURL'))
  const targetRef = useRef(null);
  const [viewImg, setViewImg] = useState();
  const [viewvideo, setViewVideo] = useState()
  const [isViewImage, setIsViewImage] = useState(true)

  useEffect(() => {
    const scrollToNext = () => {
      if (targetRef.current) {
        targetRef.current.scrollIntoView();
      }
    };
    window.addEventListener('scrollToNext', scrollToNext);
    return () => {
      window.removeEventListener('scrollToNext', scrollToNext);
    };
  }, []);


  const weight = useSelector((state) => state.weight?.value);
  const dispatch = useDispatch()
  const calculateTotalAmount = (price, weight) => {

    if (boxName == 'Normal Box') {
      return parseInt(price / 400 * weight)
    }
    else if (boxName == '4 Section in box') {
      return parseInt((price / 400) * weight / 4)
    }
    else if (boxName == '3 Section in box') {
      return parseInt((price / 400) * weight / 3)
    } else {
      return parseInt((price / 400) * weight / 5)
    }
  }



  const getInvitationData = async () => {
    await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/invitation/${_id}`).then((res) => {
      setInvitationsweet(res?.data?.invitation);
      serPrice(res?.data?.invitation?.price);
      setinvitationId(res?.data?.invitation?._id);
      setInvitation(res?.data?.invitation);
    }).catch((error) => {
      console.log(error, "error")
    })
  }

  useEffect(() => {
    if (!_id || hasFetchedRef.current) return;
    getInvitationData()
    hasFetchedRef.current = true;
  }, [_id])

  useEffect(() => {
    if (!userId || !invitation?._id) return

    const recentData = {
      userId: userId,
      fruitId: invitation?._id, name: invitation?.name, image: invitation?.image,
      price: invitation?.price ?? null,
      isSweet: invitation?.isSweet ?? null
    }
    axios.post(`${process.env.REACT_APP_BASE_URL}api/user/recent-view`, recentData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((res) => {
      console.log(res);
    }).catch((error) => {
      console.log(error, "error")
    })

  }, [invitation])


  const validate = () => {
    const newError = []

    if (boxName == 'Normal Box') {
      if (amounts[0] == 0) {
        newError.push({
          id: 0,
          boxName: 'Normal Box'
        })
      }
    }
    else if (boxName == '4 Section in box') {
      if (amounts[0] == 0) {
        newError.push({
          id: 0,
          boxName: '4 Section in box'
        })
      }
      if (amounts[1] == 0) {
        newError.push({
          id: 1,
          boxName: '4 Section in box'
        })
      }
      if (amounts[2] == 0) {
        newError.push({
          id: 2,
          boxName: '4 Section in box'
        })
      }
      if (amounts[3] == 0) {
        newError.push({
          id: 3,
          boxName: '4 Section in box'
        })
      }
    }
    else if (boxName == '3 Section in box') {
      if (amounts[0] == 0) {
        newError.push({
          id: 0,
          boxName: '3 Section in box'
        })
      }
      if (amounts[1] == 0) {
        newError.push({
          id: 1,
          boxName: '3 Section in box'
        })
      }
      if (amounts[2] == 0) {
        newError.push({
          id: 2,
          boxName: '3 Section in box'
        })
      }
    } else {
      if (amounts[0] == 0) {
        newError.push({
          id: 0,
          boxName: 'Special box'
        })
      }
      if (amounts[1] == 0) {
        newError.push({
          id: 1,
          boxName: 'Special box'
        })
      }
      if (amounts[2] == 0) {
        newError.push({
          id: 2,
          boxName: 'Special box'
        })
      }
      if (amounts[3] == 0) {
        newError.push({
          id: 3,
          boxName: 'Special box'
        })
      }
      if (amounts[4] == 0) {
        newError.push({
          id: 4,
          boxName: 'Special box'
        })
      }
    }

    setError(newError);
    return newError?.length > 0
  }


  const handleAmount = () => {
    const token = context?.token || localStorage.getItem('token')
    console.log("token", token)
    if (!token) {
      navigate('/signup')
      return
    }
    console.log("after", token)
    if (validate()) {
      return;
    }
    setTotalAmountInv(total + price)
    // navigate('/invitation-GuestList', { state: { amount: total + price } })
    const sum = total + price;
    navigate(`/invitation-GuestList/${sum}`, { state: { invitationId: invitationId } })

  }

  useEffect(() => {

    if (selectedSweet?.index >= 0 && selectedSweet?.index < amounts?.length) {
      const updatedAmounts = [...amounts];
      const calculateAmount = calculateTotalAmount((selectedSweet?.amount)?.split("/")[0], weight);
      updatedAmounts[selectedSweet?.index] = calculateAmount;
      setId(getSweet?.showId)
      setAmounts(updatedAmounts);
      const updatedHistory = paymentHistory?.filter((ele) => ele?.index != selectedSweet?.index) || [];
      updatedHistory.push({ index: selectedSweet?.index, name: selectedSweet?.sweetName, img: selectedSweet?.image, sweetId: selectedSweet?.sweetId })
      setPaymentHistory(updatedHistory)
    }
  }, [selectedSweet]);


  useEffect(() => {
    setTotal(amounts?.reduce((item1, item2) => item1 + item2))
  }, [amounts])

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setIsSuccessModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmitSuccess = () => {
    setIsModalOpen(false);
    setIsSuccessModalOpen(true);
  };

  const handleCloseSuccessModal = () => {
    setIsSuccessModalOpen(false);
  };

  const handleBoxType = (ele) => {
    setTotalAmountInv(0)
    setPaymentHistory([])
    setAmounts([0, 0, 0, 0, 0])
    setBoxName(ele?.boxName)
    setId(ele?.id)
  }



  const handleWeight = (weight) => {
    // setWeight(weight)   ----->  used for context
    dispatch(chnageWeight(weight))      //------>  redux
  }

  const handleBack = () => {
    setTotalAmountInv(0)
    setAmounts([0, 0, 0, 0, 0])
    setPaymentHistory([])
    // setWeight(500)    ----->context   
    dispatch(chnageWeight(1000))   // redux
    setBoxName('Normal Box');

    if (url == 'home') {
      navigate('/')
    } else {
      navigate("/invitation")
    }
  }

  const handleHome = () => {
    navigate('/')
  }

  useEffect(() => {
    console.log(lastURL, 'lasturl', currentUrl)
    if (currentUrl && currentUrl == '/payment-history') {
      console.log(boxName == 'Normal Box' ? 1 : boxName == '4 Section in box' ? 2 : boxName == '3 Section in box' ? 3 : 4, "222299")
      setId(boxName == 'Normal Box' ? 1 : boxName == '4 Section in box' ? 2 : boxName == '3 Section in box' ? 3 : 4)
    }
    else if (currentUrl && currentUrl !== '/sweets') {
      setBoxName('Normal Box');
      setAmounts([0, 0, 0, 0, 0]);
    }
  }, [lastURL]);

  const handleViewImg = (img) => {
    setIsViewImage(true)
    setViewImg(img)
  }

  const handleCart = () => {
    const cartDetails = {
      invitationId, weight, paymentHistory, userId, tempId: id, boxName, sectionBoxName: selectedSweet?.name || 'normal_box'
    }
    axios.post(`${process.env.REACT_APP_BASE_URL}api/user/add-cart`, cartDetails, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((res) => {
      toast.success("Added to cart successfully", {
        position: 'top-right'
      })
    }).catch((error) => {
      console.log(error);
    })
  }

  console.log(id, "paymentHistory", paymentHistory, "selectedSweet", selectedSweet)

  const handleAddCart = (e) => {
    const cartDetails = {
      invitationId, weight, paymentHistory, userId, tempId: id, boxName, sectionBoxName: selectedSweet?.name || 'normal_box', status: true
    }
    axios.post(`${process.env.REACT_APP_BASE_URL}api/user/add-cart`, cartDetails, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((res) => {
      toast.success("Item saved for later.", {
        position: 'top-right'
      })
    }).catch((error) => {
      console.log(error);
    })
  }

  const handleVideo = (url) => {
    setIsViewImage(false)
    setViewVideo(url);
  }


  return (
    <div className="invitation-details-container">

      <div className='back-button' onClick={handleBack}>   <img src={backArrow} />back</div>
      <div className="invitation-detils-home-container">
        <div className="invitation-detail-home" onClick={handleHome}>Home</div>
        <div> &nbsp;> &nbsp;Detail</div>
      </div>

      <div className="top-section">
        <div className="image-container">

          {isViewImage ? <img src={`${process.env.REACT_APP_BASE_URL}uploads/${viewImg ? viewImg : invitation?.image}`} alt={`${invitation?.image} Invitation Box`} className="invitation-image" /> :

            <video
              className="invitation-image" style={{ objectFit: 'contain' }}
              controls
            >
              <source
                src={`${process.env.REACT_APP_BASE_URL}uploads/${viewvideo}`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          }

        </div>
        <div className="invitation-description">
          <h2>
            {invitation?.name?.charAt(0)?.toUpperCase() + invitation?.name?.slice(1)?.toLowerCase()}

            (Rs. {price}/-)</h2>
          <p className="description-label">Description</p>
          <p>{invitation?.description}</p>
          <div className='invitation-customize-btn'>
            <button className="customize-btn" onClick={handleOpenModal}>
              Customize
            </button>
            {
              token && <button className="customize-btn" onClick={handleAddCart}>
                Save for Later
              </button>
            }
          </div>
        </div>
      </div>

      <div className='multipleImg-container'>

        {invitation?.videoFile && (
          // <div>
          //   <video onClick={() => { handleVideo(invitation?.videoFile) }}
          //     style={{ height: '100px', width: '100px', objectFit: 'contain', borderRadius: '8px' }}

          //   >
          //     <source
          //       src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.videoFile}`}
          //       type="video/mp4"
          //     />
          //     Your browser does not support the video tag.
          //   </video>
          // </div>
          <div style={{ position: 'relative', width: '100px', height: '100px' }}>
            <video
              onClick={() => handleVideo(invitation?.videoFile)}
              style={{
                height: '100px',
                width: '100px',
                objectFit: 'contain',
                borderRadius: '8px',
                border: '2px solid #ccc', // Add border
                cursor: 'pointer'
              }}
            >
              <source
                src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.videoFile}`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none'
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="white"
                stroke="black"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: '50%' }}
              >
                <polygon points="9.5,7.5 16.5,12 9.5,16.5" />
              </svg>
            </div>
          </div>
        )}
        <img className='multipleImg' onClick={() => handleViewImg(invitation?.image)} src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.image}`} alt={`${invitation?.image} Invitation Box`} />
        <img className='multipleImg' onClick={() => handleViewImg(invitation?.image02)} src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.image02}`} alt={`${invitation?.image} Invitation Box`} />
        <img className='multipleImg' onClick={() => handleViewImg(invitation?.image03)} src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.image03}`} alt={`${invitation?.image} Invitation Box`} />
        <img className='multipleImg' onClick={() => handleViewImg(invitation?.image04)} src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.image04}`} alt={`${invitation?.image} Invitation Box`} />
        {/* <img className='multipleImg' onClick={() => handleViewImg(invitation?.videoFile)} src={`${process.env.REACT_APP_BASE_URL}uploads/${invitation?.videoFile}`} alt={`${invitation?.image} Invitation Boxss`} /> */}

      </div>
      <div className='select-size-header'>Select size of the box</div>
      <div className='invitation-size-box'>
        <div className={weight != 750 && weight != 500 && weight != 250 ? 'right-icon-arrow' : 'invitation-default-style'} >
          {weight != 750 && weight != 500 && weight != 250 ?
            <div className='invitation-icon-shift'><img src={rightArrow} /></div> : <div className='invitation-icon-hide'><img src={rightArrow} /></div>
          }
          <div className='invitation-size-list' onClick={() => handleWeight(1000)}>
            <div><img className='invittions-size-img' src={Rectangle} /></div>
            <div>
              {/* <div className='invitation-len-h'>L:50cm</div>
              <div className='invitation-len-h'>W:50cm</div> */}
              <div className='invitation-box-we'>Weight:1000gm</div>
            </div>
          </div>
        </div>
        <div className={weight == 750 ? 'right-icon-arrow' : 'invitation-default-style'} >
          {weight == 750 ?
            <div className='invitation-icon-shift'><img src={rightArrow} /></div> : <div className='invitation-icon-hide'><img src={rightArrow} /></div>
          }

          <div className='invitation-size-list' onClick={() => handleWeight(750)}>
            <div><img className='invitation-second-img' src={boxSize2} /></div>
            <div>
              {/* <div className='invitation-len-h'>L:50cm</div>
              <div className='invitation-len-h'>W:50cm</div> */}
              <div className='invitation-box-we'>Weight:750gm</div>
            </div>
          </div>
        </div>
        <div className={weight == 500 ? 'right-icon-arrow' : 'invitation-default-style'} >
          {weight == 500 ?
            <div className='invitation-icon-shift' ><img src={rightArrow} /></div> : <div className='invitation-icon-hide'><img src={rightArrow} /></div>
          }
          <div className='invitation-size-list' onClick={() => handleWeight(500)}>
            <div ><img className='invitation-third-img' src={boxSize3} /></div>
            <div>
              {/* <div className='invitation-len-h'>L:50cm</div>
              <div className='invitation-len-h'>W:50cm</div> */}
              <div className='invitation-box-we'>Weight:500gm</div>
            </div>
          </div>
        </div>
        <div className={weight == 250 ? 'right-icon-arrow' : 'invitation-default-style'} >
          {weight == 250 ?
            <div className='invitation-icon-shift'><img src={rightArrow} /></div> : <div className='invitation-icon-hide'><img src={rightArrow} /></div>
          }
          <div className='invitation-size-list' onClick={() => handleWeight(250)}>
            <div><img className='invittions-size-img' src={Rectangle} /></div>
            <div>
              {/* <div className='invitation-len-h'>L:50cm</div>
              <div className='invitation-len-h'>W:50cm</div> */}
              <div className='invitation-box-we'>Weight:250gm</div>
            </div>
          </div>
        </div>
      </div>
      <div className='invitation-box-header'>
        <div className='invitation-box-type-header'> Select box type</div>
        <div className='invitation-box-type' >
          {boxType?.map((ele) => (
            <div className={boxName == ele?.boxName ? 'invittion-box-container' : 'invittion-default-style-container'}  >
              {
                boxName == ele?.boxName ? <div className='invitation-icon-shift'><img src={rightArrow} /></div>
                  : <div className='invitation-default-icon-shift'><img src={rightArrow} /></div>
              }
              <div className='invittion-box-detail' onClick={() => handleBoxType(ele)}>
                <div className='invitation-box-numbers'>{ele?.number}</div>
                <div className='invitation-box-name'> {ele.boxName}</div>
                <div className='invitation-box-type-img'><img src={ele?.boxImg} /></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='invitation-select-sweet-box-list' ref={targetRef}>
        <div className='invitation-box-select-header'>
          <div id="section">Sections</div>
          <div className='invitation-names'>Image</div>
          <div >Sweets</div>
          <div className='invitation-names'>Price</div>
        </div>

        {id == 1 ?
          normalBox?.map((ele, index) => {
            const data = paymentHistory?.find((ele1) => ele1.index === index);
            console.log(data, "ffffffffffffffffffffffffffffff")
            return (
              <div className='invitation-select-arrow'>
                <div className='invitation-section-align'>
                  <div className='show-selection'><img src={ele?.sectionImg} /></div>
                  <div><img src={ele?.arrow} /></div>
                  <div>
                    <Link to={ele?.url} state={{ data: true, idx: index, invitationId: invitationId, name: ele?.name, id: id }} >
                      {data ? <img className='selected-img' src={`${process.env.REACT_APP_BASE_URL}uploads/${data?.img}`} /> : <img className='select-sweet-img' src={ele?.sweetImg} />}
                    </Link>
                    {error?.some((item) => item.id == index && item.boxName == 'Normal Box') && <div className='error-color'>please select sweet</div>}
                  </div>
                </div>
                <div className='sweet-name'> {data ? data?.name[0].toUpperCase() + data?.name.slice(1).toLowerCase() : <span className='sweet-name'>Sweet Name</span>}</div>
                <div className='invitation-select-box-sweet-price'>  {
                  (selectedSweet?.invitationId === invitationId && ele.name === selectedSweet?.name)
                    ? (amounts[index] ?? 0)
                    : '₹0'
                }</div>

              </div>
            )
          }) : (id == 2) ?
            sectionBox4?.map((ele, index) => {
              console.log(ele, "ele-------")
              const data = paymentHistory?.find((ele1) => ele1.index === index);
              return (
                <div className='invitation-select-arrow'>
                  <div className='invitation-section-align'>
                    <div className='show-selection'><img src={ele?.sectionImg} /></div>
                    <div><img src={ele?.arrow} /></div>
                    <div>
                      <Link to={ele?.url} state={{ data: true, idx: index, invitationId: invitationId, name: ele?.name, id: id }}>
                        {data ? <img className='selected-img' src={`${process.env.REACT_APP_BASE_URL}uploads/${data?.img}`} /> : <img className='select-sweet-img' src={ele?.sweetImg} />}
                      </Link>
                      {error?.some((item) => item.id == index && item.boxName == '4 Section in box') && <div className='error-color'>please select sweet</div>}
                    </div>
                  </div>
                  <div className='sweet-name'> {data ? data?.name[0].toUpperCase() + data?.name.slice(1).toLowerCase() : <span>Sweet Name</span>}</div>
                  <div className='invitation-select-box-sweet-price'>  {
                    (selectedSweet?.invitationId === invitationId && ele.name === selectedSweet?.name)
                      ? (amounts[index] ?? 0)
                      : '₹0'
                  }</div>

                </div>)
            }) : (id == 3) ?
              sectionBox3?.map((ele, index) => {
                const data = paymentHistory?.find((ele1) => ele1.index === index);

                return (
                  <div className='invitation-select-arrow'>
                    <div className='invitation-section-align'>
                      <div className='show-selection'><img src={ele?.sectionImg} /></div>
                      <div><img src={ele?.arrow} /></div>
                      <div>
                        <Link to={ele?.url} state={{ data: true, idx: index, invitationId: invitationId, name: ele?.name, id: id }}>
                          {/* <img className='select-sweet-img' src={ele?.sweetImg} /> */}
                          {data ? <img className='selected-img' src={`${process.env.REACT_APP_BASE_URL}uploads/${data?.img}`} /> : <img className='select-sweet-img' src={ele?.sweetImg} />}
                        </Link>
                        {error?.some((item) => item.id == index && item.boxName == '3 Section in box') && <div className='error-color'>please select sweet</div>}
                      </div>

                    </div>

                    <div className='sweet-name'> {data ? data?.name[0].toUpperCase() + data?.name.slice(1).toLowerCase() : <span>Sweet Name</span>}</div>

                    <div className='invitation-select-box-sweet-price'>  {
                      (selectedSweet?.invitationId === invitationId && ele.name === selectedSweet?.name)
                        ? (amounts[index] ?? 0)
                        : '₹0'
                    }</div>

                  </div>
                )
              }) :
              specialBox?.map((ele, index) => {
                const data = paymentHistory?.find((ele1) => ele1.index === index);
                return (
                  <div className='invitation-select-arrow'>
                    <div className='invitation-section-align'>
                      <div className='show-selection'><img src={ele?.sectionImg} /></div>
                      <div><img src={ele?.arrow} /></div>
                      <div>
                        <Link to={ele?.url} state={{ data: true, idx: index, invitationId: invitationId, name: ele?.name, id: id }}>
                          {data ? <img className='selected-img' src={`${process.env.REACT_APP_BASE_URL}uploads/${data?.img}`} /> : <img className='select-sweet-img' src={ele?.sweetImg} />}
                        </Link>
                        {error?.some((item) => item.id == index && item.boxName == 'Special box') && <div className='error-color'>please select sweet</div>}
                      </div>
                    </div>
                    <div className='sweet-name'> {data ? data?.name[0].toUpperCase() + data?.name.slice(1).toLowerCase() : <span>Sweet Name</span>}</div>

                    <div className='invitation-select-box-sweet-price'>  {
                      (selectedSweet?.invitationId === invitationId && ele.name === selectedSweet?.name)
                        ? (amounts[index] ?? 0)
                        : '₹0'
                    }</div>

                  </div>
                )
              })
        }
      </div>

      <div className='invitation-total'>
        <div>Total</div>
        <div>{total + price}</div>
      </div>
      <div className='invitation-next' >
        <div onClick={() => handleAmount()}>
          Next
        </div>
      </div>

      <div className='invitation-next' >
        {token && <div onClick={() => handleCart()}>
          Add to cart
        </div>}

      </div>
      <CustomizationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onFormSubmitSuccess={handleFormSubmitSuccess}
        invitationId={invitationId}
      />
      <SuccessModal
        isOpen={isSuccessModalOpen}
        onClose={handleCloseSuccessModal}
      />
    </div>
  );
};